module.exports = __webpack_public_path__ + "img/beyond-the-hype-defi-nfts-smart-contracts.d2e271a8.png";